import React, { Component } from "react";
import LoaderModal from "../../../../modal/LoaderModal";
import { CONFIG } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";
import Fab from "@material-ui/core/Fab";
import PrintIcon from "@material-ui/icons/Print";
import { color } from "@amcharts/amcharts4/core";

class RekapTa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,
            resMessage: "",
            params: this.props.match.params,
            siswa: [],
            profesional_siswa: 0,
            profesional_prosen: 0,
            enterpreneur_siswa: 0,
            enterpreneur_prosen: 0,
            study_siswa: 0,
            study_prosen: 0,
            sekolah: "-",
            kelas: "-",
            kelasParalel: "",
            title: "-",
        };
    }

    async componentDidMount() {
        if (this.props.match.params !== undefined) {
            this.fetchReport();
            if (this.state.params.idSekolah !== "null") {
                this.setState({ title: "SEKOLAH" });
            }
            if (this.state.params.idKelas !== "null") {
                this.setState({ title: "KELAS" });
            }
            if (this.state.params.idKelasParalel !== "null") {
                this.setState({ title: "PARALEL" });
            }
        }
    }

    fetchReport = async () => {
        this.setState({ isFetching: true });
        const response = await accountManagement
            .get(CONFIG.GET_REKAP_TA, {
                params: {
                    idJadwalProfilCbt: this.state.params.idJadwalCbt,
                    idSekolah: this.state.params.idSekolah === "null" ? null : this.state.params.idSekolah,
                    idKelas: this.state.params.idKelas === "null" ? null : this.state.params.idKelas,
                    idKelasParalel: this.state.params.idKelasParalel === "null" ? null : this.state.params.idKelasParalel,
                    kodeAspek: this.state.params.kodeAspek,
                },
            })
            .catch(function (error) {
                alert(error);
            });
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    siswa: response.data.data.siswa,
                    sekolah: response.data.data.sekolah,
                    kelas: response.data.data.kelas,
                    kelasParalel: response.data.data.kelasParalel,
                    profesional_siswa: response.data.data.grafik.profesional.siswa,
                    profesional_prosen: response.data.data.grafik.profesional.prosentase,
                    enterpreneur_siswa: response.data.data.grafik.enterpreneur.siswa,
                    enterpreneur_prosen: response.data.data.grafik.enterpreneur.prosentase,
                    study_siswa: response.data.data.grafik.study.siswa,
                    study_prosen: response.data.data.grafik.study.prosentase,
                });
            }

            (function () {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = "/assets/js/easypiechart-data.js";
                document.getElementsByTagName("head")[0].appendChild(script);
            })();
            this.setState({ isFetching: false });
        }
    };

    print() {
        window.print();
    }

    render() {
        const { siswa, sekolah, title } = this.state;
        const style = {
            margin: 0,
            top: "auto",
            right: 20,
            bottom: 20,
            left: "auto",
            position: "fixed",
        };
        let kelas;
        if (this.props.match.params.idKelas !== "null") {
            kelas = this.state.kelas;
        }
        if (this.props.match.params.idKelasParalel !== "null") {
            kelas = this.state.kelas + "-" + this.state.kelasParalel;
        }
        require('./RekapTa.css')
        return (
            <>
                <LoaderModal isFetching={this.state.isFetching} />
                <div className="">
                    <div className="cardLine">
                        {/* header */}
                        <div className="pnl-header">
                            <div className="card-page">
                                <span style={{
                                    fontSize: '26px',
                                    color: '#FFF',
                                    fontWeight: 500,
                                    fontFamily: 'lucida grande'
                                }}>01</span>
                            </div>
                            <div className="pnl-date">
                                https://eduprime.co.id
                            </div>
                        </div>
                        <div className="header-first-page" style={{ padding: '0px' }}>
                            <div className="text-header" style={{ padding: '0px' }}>
                                <div className="title-header2" style={{ color: '#015E56' }}>REPORT {title}</div>
                                <div className="label-sub-tit">
                                    <span className="sub-title-header" style={{ color: '#FFF' }}>Specific Talent Analysis - Karir</span>
                                </div>
                            </div>
                            <div className="image-header">
                                <div className="logo-edu">
                                    <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                                </div>
                                <div className="logo-an">
                                    <img src="/assets/image/LOGO_AN_2.png" width={"100%"} style={{ height: '33px', width: '148px' }} />
                                </div>
                            </div>
                        </div>
                        <div className="card-profile" style={{ marginTop: '5%', marginBottom: '20px' }}>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <div>
                                    <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                                </div>
                                <div>
                                    <span className="label-profile-name">Nama Sekolah</span>
                                    <p style={{ fontSize: '20px', fontWeight: '500' }}>{sekolah}</p>
                                </div>
                            </div>
                        </div>
                        <div className="card-profile" style={{ marginBottom: '20px' }}>
                            <span className="label_persentase_potensi" style={{ color: '#424242' }}> PERSENTASE KECENDERUNGAN POTENSI SISWA </span>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '10px', marginTop: '20px' }}>
                                <div className="panel panel-default chart_percentase_potensi_siswa" style={{ width: '33.3%', textAlign: 'center' }}>
                                    <span className="label-profile-name">Profesional</span>
                                    <div className="panel-body easypiechart-panel">
                                        <div className="easypiechart chart" id="easypiechart-blue" data-percent={this.state.profesional_prosen}>
                                            <div className="label_persentase_potensi_chart">
                                                <span className="persentase_potensi">{this.state.profesional_prosen}%</span>
                                                <br />
                                                <span className="jumlah_siswa">{this.state.profesional_siswa} siswa</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel panel-default chart_percentase_potensi_siswa" style={{ width: '33.3%', textAlign: 'center' }}>
                                    <span className="label-profile-name">Entrepreneur</span>
                                    <div className="panel-body easypiechart-panel">
                                        <div className="easypiechart chart" id="easypiechart-teal" data-percent={this.state.enterpreneur_prosen}>
                                            <div className="label_persentase_potensi_chart">
                                                <span className="persentase_potensi">{this.state.enterpreneur_prosen}%</span>
                                                <br />
                                                <span className="jumlah_siswa">{this.state.enterpreneur_siswa} siswa</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel panel-default chart_percentase_potensi_siswa" style={{ width: '33.3%', textAlign: 'center' }}>
                                    <span className="label-profile-name">Lanjut Study</span>
                                    <div className="panel-body easypiechart-panel">
                                        <div className="easypiechart chart" id="easypiechart-orange" data-percent={this.state.study_prosen}>
                                            <div className="label_persentase_potensi_chart">
                                                <span className="persentase_potensi">{this.state.study_prosen}%</span>
                                                <br />
                                                <span className="jumlah_siswa">{this.state.study_siswa} siswa</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-profile" style={{ marginBottom: '20px' }}>
                            <span className="label-profile-name" style={{ color: '#424242' }}> Daftar kecenderungan Potensi Siswa </span>
                            <table className="table table-hover tbl-mpl-siswa">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th width="40%">Nama Siswa</th>
                                        <th>Professional</th>
                                        <th>Entrepreneur</th>
                                        <th>Lanjut Study</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {siswa.map((s, i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{s.nama_siswa}</td>
                                            <td>{s.profesional === 1 ? <img src="/assets/image/centang-kecil-biru.svg" width="20px" alt="" /> : <i className="fa fa-minus" aria-hidden="true"></i>}</td>
                                            <td>{s.enterpre === 1 ? <img src="/assets/image/centang-kecil-hijau.svg" width="20px" alt="" /> : <i className="fa fa-minus" aria-hidden="true"></i>}</td>
                                            <td>{s.study === 1 ? <img src="/assets/image/centang-kecil-kuning.svg" width="20px" alt="" /> : <i className="fa fa-minus" aria-hidden="true"></i>}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Fab color="primary" id="btn-print" style={style} onClick={() => window.print()}>
                        <PrintIcon />
                    </Fab>
                </div>
            </>
        );
    }
}

export default RekapTa;
